import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Route } from "react-router-dom"

import { Routes } from "helpers/sentry"

import Homepage from "./homepage"

import Article from "./"

const ArticleLanding = ({ articleData }) => {
  return (
    <Box contain pb={{ _: 4, tablet: 0 }} px={2}>
      <Routes>
        <Route
          element={<Article articleData={articleData} />}
          path=":article_path"
        />
        <Route element={<Homepage articleData={articleData} />} index />
      </Routes>
    </Box>
  )
}

ArticleLanding.propTypes = {
  articleData: PropTypes.object,
}

export default ArticleLanding
